import React from "preact/compat";
import { Odds } from "../../../💎Atoms/Odds/Odds";
import { GameInfoProps } from "./gameInfo.type";

export const GameInfo: React.FunctionComponent<GameInfoProps> = ({
  site,
  showLogo = false,
  disabled = false,
  gameData, 
  gameInfo,
  showLeague = false,
  warning = ''
}) => {
  return (
    <div>
      {gameData ? 
        <div className={`game-wager-info ${site === 'covers' ? 'fs-7' : 'fs-8'} ${showLogo ? 'd-flex' : ''}`}>
            {showLogo && gameInfo?.svgLogo ? 
                <img className="me-2" src={gameInfo?.svgLogo} alt={`${gameInfo.fullName} logo`} width={32} height={32} />
            :
              ''
            }
            <div>
              <div className={`${disabled ? 'text-gray opacity-75' : ''}`}>
                {gameData.betTitle !== '' ?
                  <b className="d-inline-block me-2 my-0 text-capitalize h4">
                    {gameData.betTitle}
                  </b> 
                : ''}
                <Odds data={gameData.betData} />
              </div>
              <div className={`d-flex justify-content-start align-items-center pt-1`}>
                {warning !== null && warning !== '' ? 
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="me-1">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.839 13.4899L9.24928 1.23571C9.00587 0.783401 8.52477 0.5 8.00035 0.5C7.47593 0.5 6.99484 0.783401 6.75142 1.23571L0.160976 13.4899C-0.0679887 13.9156 -0.051781 14.4268 0.203711 14.8379C0.459202 15.249 0.916798 15.5001 1.41026 15.5H14.5897C15.0832 15.5001 15.5408 15.249 15.7963 14.8379C16.0518 14.4268 16.068 13.9156 15.839 13.4899ZM7.29499 5.54219C7.29499 5.16304 7.61063 4.85568 8 4.85568C8.38937 4.85568 8.70501 5.16304 8.70501 5.54219V9.66124C8.70501 10.0404 8.38937 10.3477 8 10.3477C7.61063 10.3477 7.29499 10.0404 7.29499 9.66124V5.54219ZM8.01551 13.4439H8.03525C8.31521 13.4395 8.58151 13.3253 8.77392 13.1273C8.96632 12.9292 9.06856 12.6639 9.05752 12.3915C9.03482 11.8295 8.56069 11.385 7.98308 11.3844H7.96334C7.68407 11.3894 7.41858 11.5034 7.22659 11.701C7.03459 11.8985 6.93222 12.1629 6.94248 12.4347C6.96441 12.9969 7.43781 13.4421 8.01551 13.4439Z" fill="#FFD200"/>
                  </svg> 
                : ''} 
                {showLeague && gameData.game?.leagueName ? 
                  <span className={`tiny fw-semibold px-1 py-1d rounded-1 ${disabled ? 'text-gray bg-light' : 'bg-warning'} me-2`}>{gameData.game?.leagueName}</span>
                : '' }
                <span className={`text-capitalize text-gray lh-1`}>{gameData.betDescription}</span>
                
              </div>
            </div>
        </div>
      :
        ""
      }
    </div>
  )
};